import React, { useEffect, useState } from 'react';
import '../../App.css';
import { Auth } from '../../core/auth';
import {
  clearOAuthContext,
  clearOAuthSignupSession,
  finishOAuthFromUrl,
  readOAuthContext,
  storeOAuthSignupSession,
} from '../../core/oauth-flow';
import { isOAuthCallbackUrl } from '../../core/platform';

function AuthCallbackPage({ onLogin, onSignupProfile, showToast }) {
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        if (!isOAuthCallbackUrl(window.location.href)) {
          setError('Invalid sign-in callback.');
          return;
        }

        const session = await finishOAuthFromUrl(window.location.href);
        const { mode, provider } = readOAuthContext();
        clearOAuthContext();

        const result = await Auth.completeOAuth({
          accessToken: session.access_token,
          refreshToken: session.refresh_token,
          expiresIn: session.expires_in,
          expiresAt: session.expires_at ? session.expires_at * 1000 : undefined,
          provider,
          mode,
        });

        if (cancelled) return;

        window.history.replaceState({}, '', mode === 'signup' ? '/?register=1&oauth=1' : '/');

        if (result.error) {
          setError(result.error);
          return;
        }

        if (result.needsSignupProfile) {
          storeOAuthSignupSession({
            ...result.oauth,
            name: result.profile?.name,
            email: result.profile?.email,
          });
          showToast?.('Almost done — add your company details.', 'info');
          onSignupProfile?.(result.profile);
          return;
        }

        if (result.user) {
          showToast?.(`Welcome, ${result.user.name}!`, 'success');
          onLogin(result.user);
        }
      } catch (e) {
        if (!cancelled) setError(e.message || 'Sign-in failed');
        clearOAuthSignupSession();
      }
    })();

    return () => { cancelled = true; };
  }, [onLogin, onSignupProfile, showToast]);

  return (
    <div className="auth-wrap">
      <div className="auth-card" style={{ textAlign: 'center', padding: '32px 24px' }}>
        {!error ? (
          <>
            <div style={{ margin: '0 auto 16px', width: 32, height: 32, border: '3px solid var(--border)', borderTopColor: 'var(--blue)', borderRadius: '50%', animation: 'spin .7s linear infinite' }} />
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: 20 }}>Completing sign-in…</div>
            <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 8 }}>Please wait while we connect your account.</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 14, color: 'var(--red)', marginBottom: 16 }}>{error}</div>
            <a href="/" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>Back to login</a>
          </>
        )}
      </div>
    </div>
  );
}

export { AuthCallbackPage };
